import { render } from "./NoticeDetail.vue?vue&type=template&id=5353e928&scoped=true"
import script from "./NoticeDetail.vue?vue&type=script&lang=js"
export * from "./NoticeDetail.vue?vue&type=script&lang=js"

import "./NoticeDetail.vue?vue&type=style&index=0&id=5353e928&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5353e928"]])

export default __exports__